<template>
  <header>
    <b-container>
      <b-row class="py-2 py-md-2" style="padding:0px !important">
        <b-col cols="12" md="12" class="text-left">
          
        </b-col>
      </b-row>
    </b-container>
  </header>
</template>

<script>
import { mapActions } from "vuex";
//import Notify from "../ui/Notify";

export default {
  name: "app-header",
  data() {
    return {
      logo: require("../../assets/icons/logo-light.svg"),
      menus: [
        { name: "Dashboard", link: "/dashboard", icon: "fa fa-home" },
        { name: "Investments", link: "/investments", icon: "fas fa-poll" },
        { name: "Wallet", link: "/wallet", icon: "fas fa-wallet" },
        { name: "Tickets", link: "/tickets", icon: "fa fa-share" },
        { name: "Referrals", link: "/referrals", icon: "fa fa-share" }
      ]
      // userObj: this.$store.state.userObj
    };
  },
  methods: {
    ...mapActions("auth", ["logout"])
  },
  computed: {
    userObj() {
      return this.$store.state.userObj;
    },
    userAvatar() {
      return (
        this.userObj.photourl ||
        `https://ui-avatars.com/api/?name=${this.userObj.firstname}+${this.userObj.lastname}&rounded=true`
      );
    }
  },
  components: {
    //Notify
  }
};
</script>

<style lang="scss">
.profilemenu .btn {
  padding: 0 !important;
}

#user-logo {
  border-radius: 50%;
}

.avatar-wrapper {
  height: 40px;
  width: 40px;
  border: 3px solid var(--white);
  box-sizing: content-box;
  border-radius: 50%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.progress-ring__circle {
  transition: 0.35s stroke-dashoffset;
  // axis compensation
  transform: rotate(-90deg);
  transform-origin: 50% 50%;
}

.notification-counter {
  width: 20px !important;
  height: 20px !important;
}

@keyframes ripple {
  0% {
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.1),
      0 0 0 20px rgba(255, 255, 255, 0.1), 0 0 0 40px rgba(255, 255, 255, 0.1),
      0 0 0 60px rgba(255, 255, 255, 0.1);
  }
  100% {
    box-shadow: 0 0 0 20px rgba(255, 255, 255, 0.1),
      0 0 0 40px rgba(255, 255, 255, 0.1), 0 0 0 60px rgba(255, 255, 255, 0.1),
      0 0 0 80px rgba(255, 255, 255, 0);
  }
}
</style>
